export default (elem: HTMLElement | SVGSVGElement | null, offset = 0): boolean => {
  if (!elem) return false
  const { top, height } = elem.getBoundingClientRect()
  return top > -(height * (1 + offset)) && top <= window.innerHeight * (1 + offset)
}
